import React, { useState, useEffect, useRef } from "react";
import "./animation1.css";

const InfiniteHorizontalScroll = () => {
  const [items, setItems] = useState([
    {
      image: "/img/webpImg/coin.webp",
      text: "Exclusive Offers from Your Favourite Online Stores",
    },
    { image: "/img/webpImg/coin.webp", text: "Don't Miss Out!" },
    { image: "/img/webpImg/coin.webp", text: "Top Deals, Just For You" },
    { image: "/img/webpImg/coin.webp", text: "Incredible Savings Await" },
    { image: "/img/webpImg/coin.webp", text: "Limited Time Offers" },
  ]);

  const scrollContainerRef = useRef(null);
  const scrollContentRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const scrollContent = scrollContentRef.current;

    if (!scrollContainer || !scrollContent) return;

    let animationFrameId;
    let scrollPosition = 0;

    const performScroll = () => {
      // Increase scroll position
      scrollPosition -= 1;

      // Reset scroll position when it exceeds the content width
      if (Math.abs(scrollPosition) >= scrollContent.scrollWidth / 2) {
        scrollPosition = 0;
      }

      // Apply the translation
      scrollContent.style.transform = `translateX(${scrollPosition}px)`;

      // Continue the animation
      animationFrameId = requestAnimationFrame(performScroll);
    };

    // Start the scroll animation
    animationFrameId = requestAnimationFrame(performScroll);

    // Pause on hover
    const handleMouseEnter = () => {
      cancelAnimationFrame(animationFrameId);
    };

    const handleMouseLeave = () => {
      animationFrameId = requestAnimationFrame(performScroll);
    };

    scrollContainer.addEventListener("mouseenter", handleMouseEnter);
    scrollContainer.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup
    return () => {
      cancelAnimationFrame(animationFrameId);
      scrollContainer.removeEventListener("mouseenter", handleMouseEnter);
      scrollContainer.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <div className="infinite-scroll-container-react" ref={scrollContainerRef}>
      <div className="infinite-scroll-content-react" ref={scrollContentRef}>
        {[...Array(4)].map((_, repeatIndex) =>
          items.map((item, index) => (
            <div
              key={`item-${repeatIndex}-${index}`}
              className="infinite-scroll-item-react"
            >
              <img
                src={item.image}
                alt="Offer icon"
                className="infinite-scroll-image-react"
              />
              <p className="infinite-scroll-text-react">{item.text}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default InfiniteHorizontalScroll;
